var map = {
	"./br.svg": 97845,
	"./de.svg": 75716,
	"./es.svg": 63821,
	"./fr.svg": 48193,
	"./it.svg": 41926,
	"./ja.svg": 93998,
	"./ko.svg": 27899,
	"./ru.svg": 88634,
	"./us.svg": 77501,
	"./zh.svg": 28231
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 13813;